import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import EventBusPlugin from '@/plugins/EventBusPlugin';

Vue.config.productionTip = false;

Vue.use(EventBusPlugin);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
